import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchLocationGroupsRequest from "./requests/searchLocationGroupsRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const endpoints: RequestDefinitionData[] = [
    searchLocationGroupsRequest,
];

export const header = {
    title: 'Location Groups',
    description: 'This is an object representing a Fishbowl location group.',
    linkName: 'Location Groups',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Location-Group',
    endpoints: endpoints,
};

export const jsonObject: Json = {
    title: 'THE LOCATION GROUP OBJECT',
    json: {
        id: 1,
        name: "Main",
        class: {
            id: 0,
            name: "",
        },
        active: true,
        readOnly: false,
    },
};

export const attributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The location group\'s unique identification number.'
    },
    {
        name: 'name',
        type: 'string',
        description: 'The location group\'s name.'
    },
    {
        name: 'class',
        type: 'reference object',
        description: 'The class category.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'active',
        type: 'boolean',
        description: 'The location group\'s active status.'
    },
    {
        name: 'readOnly',
        type: 'boolean',
        description: 'Whether the current user has read-only access for this location group.'
    },
];
